import _ from 'lodash'
import { disablePageScroll, enablePageScroll } from 'scroll-lock'

const OPTION_SELECTED_CLASS = 'outline-black'
const OPTION_SELECTED_CLASS_DARK = '[.is-dark-mode_&]:outline-white'
const OPTION_SELECTED_CLASS_BORDER = 'product-card-selected'
const OPTION_COLOR_SELECTOR = '.js-product-color'
const PRODUCT_CARD_SELECTOR = '.js-product-card'
const PRODUCT_CARD_HOVER_SELECTOR = '.js-product-card-hover'
const PRODUCT_CARD_IMAGE_SELECTOR = '.js-product-card-image'
const YOTPO_DESKTOP_SELECTOR = '.js-review-desktop'
const YOTPO_MOBILE_SELECTOR = '.js-review-mobile'
const WISH_LIST_BTN_SELECTOR = '.js-add-to-wishlist'
const WISH_LISTED_CLASS = 'is-wish-listed'
const IN_VIEWPORT_CLASS = 'product-card--in-viewport'
const PRODUCT_CARD_ADD_TO_CART_SELECTOR = '.js-product-card-add-to-cart'
const PRODUCT_CARD_VARIANTS_SELECTOR = '.js-product-card-variants'
const PRODUCT_CARD_BUTTON_SELECTOR = '.js-product-card-button'
const PRODUCT_CARD_BUTTON_MOBILE_SELECTOR = '.js-product-card-button-mobile'
const QUICK_VIEW_PRODUCT_SELECTOR  = '.js-quick-view-product'
const QUICK_VIEW_MODAL_SELECTOR = '.js-quick-view-modal'
const QUICK_VIEW_MODAL_CONTENT_SELECTOR = '.js-quick-view-modal-content'
const QUICK_VIEW_CLOSE_MODAL_SELECTOR = '.js-modal-close'
const QUICK_VIEW_PRODUCT_FORM_SELECTOR = '.js-quick-view-product-form'
const SHOW_QUICK_VIEW_CLASS = 'show-quick-view'
const SHOW_VARIANTS_CLASS = 'show-variants'

class ProductCard extends HTMLElement {
  constructor () {
    super()

    const productCardEl = this.querySelector(PRODUCT_CARD_SELECTOR)
    const optionColorEls = productCardEl?.querySelectorAll(OPTION_COLOR_SELECTOR)
    const productCardHoverEl = this.querySelector(PRODUCT_CARD_HOVER_SELECTOR)
    const optionColorHoverEls = productCardHoverEl?.querySelectorAll(OPTION_COLOR_SELECTOR)
    const wishListButtonEl = this.querySelector(WISH_LIST_BTN_SELECTOR)
    const yotpoDesktopEl = this.querySelector(YOTPO_DESKTOP_SELECTOR)
    const yotpoMobileEl = this.querySelector(YOTPO_MOBILE_SELECTOR)
    const formEl = this.querySelector(PRODUCT_CARD_ADD_TO_CART_SELECTOR)
    const buttonProductFormEls = this.querySelectorAll(PRODUCT_CARD_BUTTON_SELECTOR)

    if (this.dataset?.variants) {
      this.variants = JSON.parse(this.dataset?.variants)
    }

    wishListButtonEl && wishListButtonEl.addEventListener('click', this.toggleWishList.bind(this))
    optionColorEls && productCardEl && this.selectColor(productCardEl, optionColorEls)
    productCardHoverEl && optionColorHoverEls && this.selectColor(productCardHoverEl, optionColorHoverEls)
    if (formEl) {
      this.handleQuickview(formEl)
    }

    if (productCardEl) {
      this.hideQuickview(productCardEl)
    }

    if (formEl && buttonProductFormEls.length > 0) {
      this.showQuickViewMobile(formEl, buttonProductFormEls);
    }

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.classList.add(IN_VIEWPORT_CLASS)
        observer.disconnect()
      }
    }, {});
    observer.observe(this)

    if (yotpoDesktopEl) {
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            const starsEl = yotpoDesktopEl.querySelector('.yotpo-bottomline a')
            if (starsEl) {
              this.editReviewMarkup(starsEl)
            }
            mutationObserver.disconnect()
          }
        }
      }

      const mutationObserver = new MutationObserver(callback)
      mutationObserver.observe(yotpoDesktopEl, { attributes: true, childList: true, subtree: true })
    }

    if (yotpoMobileEl) {
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            const starsEl = yotpoMobileEl.querySelector('.yotpo-bottomline a')
            if (starsEl) {
              this.editReviewMarkup(starsEl)
            }
            mutationObserverMobile.disconnect()
          }
        }
      }

      const mutationObserverMobile = new MutationObserver(callback)
      mutationObserverMobile.observe(yotpoMobileEl, { attributes: true, childList: true, subtree: true })
    }
  }

  hideQuickview () {
    this.addEventListener('mouseleave', () => {
      setTimeout (() => {
        this.classList.remove(SHOW_VARIANTS_CLASS)
      }, 200)
    })
  }

  editReviewMarkup (starsEl) {
    const content = starsEl.innerHTML
    starsEl.innerHTML = content.split(' ')[0] || starsEl.innerHTML
  }

  handleQuickview(formEl) {
    if (!formEl) {
      return
    }

    const formVariantsEl = formEl.querySelector(PRODUCT_CARD_VARIANTS_SELECTOR)

    formEl.addEventListener('submit', (event) => {
      event.preventDefault()
      if (formVariantsEl) {
        this.showVariantsDesktop()
      } else {
        const shopifyCart = document.querySelector('shopify-cart')
        if (shopifyCart) {
          shopifyCart.addItemFromForm(formEl)
        }
      }
    })
  
    formEl.addEventListener('change', (event) => {
      if (event.target.closest('[data-option]')) {
        this.onOptionChange(event, formEl)
      }
    })
  }

  onOptionChange (event, formEl) {
    const productCardButtonMobileEl = formEl.querySelector(PRODUCT_CARD_BUTTON_MOBILE_SELECTOR)
    const option1 = formEl.querySelector('[data-option="1"] input[type="radio"]:checked')
    const option2 = formEl.querySelector('[data-option="2"] input[type="radio"]:checked')
    const option3 = formEl.querySelector('[data-option="3"] input[type="radio"]:checked')
  
    let matchingVariant = _.find(this.variants, {
      option1: option1 ? option1.value : null,
      option2: option2 ? option2.value : null,
      option3: option3 ? option3.value : null
    })
  
    if (matchingVariant && matchingVariant.id) {
      this.updateCurrentOptionName(event, matchingVariant)
      formEl.querySelector('input[name="id"]').value = matchingVariant.id
      if (window.matchMedia('(min-width: 1024px)').matches) {
        document.querySelector('shopify-cart').addItemFromForm(formEl)
      } else {
        if (productCardButtonMobileEl) {
          const textButton = productCardButtonMobileEl.dataset?.textButton
          productCardButtonMobileEl.innerHTML = textButton || ''
          productCardButtonMobileEl.disabled = false
  
          const newButtonEl = productCardButtonMobileEl.cloneNode(true)
          productCardButtonMobileEl.replaceWith(newButtonEl)
  
          newButtonEl.addEventListener('click', (event) => {
            event.preventDefault()
            document.querySelector('shopify-cart').addItemFromForm(formEl)
            setTimeout(() => {
              this.hideQuickViewModal()
            }, 500)
          })
        }
      }
    }
  }

  updateCurrentOptionName (event, variant) {
    const optionEl = event.target.closest('[data-option]')
    if (!optionEl) {
      return
    }
  
    const optionNameEl = optionEl.querySelector('[data-option-value]')
    if (!optionNameEl) {
      return
    }

    const optionName = 'option' + optionEl.dataset.option;
    const optionText = variant[optionName] ? variant[optionName].split('|') : []

    optionNameEl.innerHTML = optionText.length > 1 ? optionText[1] : (variant[optionName] || '')
    optionEl.classList.add('is-active-variant')
  }

  showVariantsDesktop () {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      this.classList.add(SHOW_VARIANTS_CLASS)
    }
  }

  showQuickViewMobile(formEl, buttonEls) {
    buttonEls.forEach(buttonEl => {
      buttonEl.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 1023px)').matches) {
          const formVariantsEl = formEl.querySelector(PRODUCT_CARD_VARIANTS_SELECTOR)

          if (formVariantsEl) {
            const productHandle = buttonEl.dataset?.productHandle

            if (productHandle) {
              this.makeRequest(productHandle)
            }
          } else {
            const shopifyCart = document.querySelector('shopify-cart')

            if (shopifyCart) {
              shopifyCart.addItemFromForm(formEl)
              setTimeout(() => {
                this.hideQuickViewModal()
              }, 500)
            }
          }
        }
      })
    })
  }

  renderQuickViewProductContent (renderedProductEl, modalEl, modalContentEl) {
    if (!renderedProductEl || !modalEl || !modalContentEl) {
      return
    }

    modalContentEl.innerHTML = renderedProductEl.innerHTML

    const formEl = modalEl.querySelector(QUICK_VIEW_PRODUCT_FORM_SELECTOR)
    const closeEls = modalEl.querySelectorAll(QUICK_VIEW_CLOSE_MODAL_SELECTOR)
  
    if (formEl) {
      this.showQuickViewModal()
      formEl.addEventListener('change', (event) => {
        if (event.target.closest('[data-option]')) {
          this.onOptionChange(event, formEl)
        }
      })
    }

    if (closeEls.length > 0) {
      closeEls.forEach(closeEl => {
        closeEl.addEventListener('click', (event) => {
          event.preventDefault()
          this.hideQuickViewModal()
        })
      })
    }
  }

  showQuickViewModal () {
    document.body.classList.add(SHOW_QUICK_VIEW_CLASS)
    disablePageScroll()
  }

  hideQuickViewModal () {
    const menuSlideoutEl = this.closest('menu-slideout')
    document.body.classList.remove(SHOW_QUICK_VIEW_CLASS)

    enablePageScroll()

    if (menuSlideoutEl && typeof menuSlideoutEl.closeDrawer === 'function') {
      menuSlideoutEl.closeDrawer()
    }
  }

  async makeRequest (productUrl) {
    const quickViewModalEl = document.querySelector(QUICK_VIEW_MODAL_SELECTOR)
    if (!productUrl || !quickViewModalEl) return
  
    const fetchUrl = `/products/${productUrl}?view=quick-view`
  
    try {
      const response = await fetch(fetchUrl)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const responseText = await response.text()
      const domParser = new DOMParser()
      const responseDoc = domParser.parseFromString(responseText, 'text/html')
  
      const renderedProductEl = responseDoc.querySelector(QUICK_VIEW_PRODUCT_SELECTOR)
      const quickViewModalContentEl = quickViewModalEl.querySelector(QUICK_VIEW_MODAL_CONTENT_SELECTOR)

      if (renderedProductEl && quickViewModalContentEl) {
        this.renderQuickViewProductContent(renderedProductEl, quickViewModalEl, quickViewModalContentEl)
      }
    } catch (error) {
      console.error('Error fetching product data:', error)
    }
  }
 
  selectColor (parent, options) {
    const _this = this
    options.forEach(element => {
      const activateColor = () => {
        const imageFeatured = element.dataset.featuredImage
        const productCardImageEl = parent.querySelector(PRODUCT_CARD_IMAGE_SELECTOR)
        productCardImageEl.setAttribute('src', imageFeatured)
        productCardImageEl.setAttribute('srcset', imageFeatured)
        _this.initOptionColor(options)
        element.classList.add(OPTION_SELECTED_CLASS, OPTION_SELECTED_CLASS_DARK, OPTION_SELECTED_CLASS_BORDER)
      }

      element.addEventListener('click', activateColor)
      element.addEventListener('keydown', (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
          activateColor()
        }
      })
    })
  }

  initOptionColor (els) {
    els.forEach(el => {
      el.classList.remove(OPTION_SELECTED_CLASS, OPTION_SELECTED_CLASS_DARK, OPTION_SELECTED_CLASS_BORDER)
    })
  }

  toggleWishList () {
    this.classList.toggle(WISH_LISTED_CLASS)
  }
}
if (!customElements.get('product-card')) customElements.define('product-card', ProductCard)
